import httpClient from "./httpClient";

const  getAllContacts = () => httpClient.get(`/MainPage/ContactInf/Get`,).then(
  (res) => res.data.results
)

const postContacts = (params) => httpClient.post(`/MainPage/ContactInf/Post` , {
  informationNo: params.informationNo,
  customerServiceNo: params.customerServiceNo,
  email: params.email
},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
const putContacts = (params, id) => httpClient.put(`/MainPage/ContactInf/Put/${id}` , {
  id: id ,
  informationNo: params.informationNo,
  customerServiceNo: params.customerServiceNo,
  email: params.email
},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })



const getMessage =  (page , pageSize) => httpClient.get(`/Messages?page=${page}&pageSize=${pageSize}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
  .then(
  (response) => {return response.data}
  )
const deleteMessage = (id) => httpClient.delete(`/Messages/${id}`)
const postReply = (params) => httpClient.post(`/Messages/Reply`, params)
const putMessage = (id,params) => httpClient.put(`/Messages/${id}`, {
  id : id,
  solved: params.solved,
  category: params.category
})

export {
  putContacts,
  getAllContacts,
  postContacts,
  getMessage,
  deleteMessage,
  postReply,
  putMessage,
}
